export const cn = {
  'already_logout': '已登出，请再次登入',
  'logout': '登出',
  'user_login': '登入学习系统',
  'username': '账号',
  'password': '密码',
  'login': '登录账号',
  'hide_video': '收合影片',
  'view_video': '展开影片',
  'slow_audio_playback': '慢速音档播放中',
  'video_transcript': '课程文章',
  'wordbank': '课程单字',
  'highlights': '课程重点',
  'slow_playback': '慢速',
  'view_translation': '翻译',
  'dictionary': '字典',
  'fill_in_the_blanks': '听力填空',
  'multiple_choice': '听力理解',
  'complete_the_sentence': '翻译填空',
  'unscramble_the_sentences': '句子重组',
  'the_assessment_begin_description': '您即将开始进行能力检测。本能力检测依照：听力、字汇片语、文法句型、阅读分为四个部分，每个部分约为12-16题，题目的难易度会依照答题的正确率而调整。 ',
  'start_test': '开始测验',
  'next': '下一题',
  'assessment_completed_description': '恭喜您已经完成能力检测！ ',
  'recommendation_according_assessment_result': '本系统将依据您的检测结果，提供您推荐课程。您可以点选看分析查看刚才的考试结果，或是点选推荐课程，开始观看线上课程。 ',
  'view_result': '看分析',
  'my_recommendation': '推荐课程',
  'view_assessment_history': '检视过去能力纪录',
  'assessment': '开始能力检测',
  'view_recommendation': '前往推荐课程',
  'assessment_history': '历史纪录',
  'view_list': '显示清单',
  'detail': '查看',
  'assessment_test': '能力检测',
  'listening_skill': '听力能力',
  'reading_skill': '阅读能力',
  'vocabulary_skill': '单字能力',
  'grammar_skill': '文法能力',
  'test_date': '测验日期',
  'period': '考试日期',
  'title': '考试名称',
  'assigned_by': '指派老师',
  'listening': '听力',
  'reading': '阅读',
  'total': '总分',
  'pass': '通过',
  'no_pass': '未通过',
  'take_test': '功能',
  'n_a': '无',
  'not_released': '未开放',
  'test_is_over': '已结束',
  'go_test': '考试',
  'completed': '已完成',
  'no_test_found': '目前无考试资料',
  'my_test': '考试作业',
  'new_test': '新增考试',
  'added_on': '建立日期',
  'assisgnment_history': '指派清单',
  'assign': '指派',
  'edit': '编辑',
  'view_score': '检视成绩',
  'delete': '删除',
  '_download': '下载',
  'assignment_deleting_notice': '考试指派中，若删除清单，纪录会一并删除。 ',
  'deleting_confirm': '确定要删除？ ',
  'yes': '确认',
  'cancel': '取消',
  'has_been_assigned_to': '已经指派给',
  'no_assignment_has_been_made': '目前无指派资讯',
  'deleting_assignment_confirm': '确定要删除指派？ ',
  'assign_to': '您要指派 [{msg}] 给',
  'no_class_is_assigned': '目前无班级资讯',
  'submit_assign': '确认指派',
  'set_duration_of': '设定 [{msg}] 的指派时间',
  'class': '班级',
  'from': '开始时间',
  'to': '结束时间',
  'test_result_of': '检视 [{msg}] 的指派班级成绩',
  'more': '详细内容',
  'please_check_time_format': '请检查时间格式有无正确',
  'please_enter_valid_datetime': '指派时间错误',
  'replace': '更新考试',
  'add_test': '建立考试',
  'select': '选择试卷',
  'test': '试卷名称',
  'level': '级别',
  'time_used': '使用次数',
  'preview': '预览试卷',
  'download': '预览',
  'please_name_this_test': '考试名称不得为空白',
  'please_choose_a_test': '需选择试卷',
  'finish': '交卷',
  'test_completed': '完成考试',
  'class_name': '班级名称',
  'teacher': '指导老师',
  'list_of_students': '学生名单',
  'edit_list': '编辑名单',
  'edit_class': '编辑班级',
  'add_class': '新增班级',
  'import_class_information': '汇入班级',
  'export_all_classes': '汇出全部班级',
  'download_list_of_class': '下载班级清单',
  'no_class_found': '目前无任何班级',
  'file': '档案',
  'download_template': '范本下载',
  'class_management': '班级管理',
  'class_information': '班级资料',
  'import_list_of_students': '汇入学生名单',
  'add_current_student': '从现有学生新增',
  'add_new': '单笔新增',
  'remove': '移除',
  'add': '加入',
  'at_least_4_characters': '需大于四位数',
  'name': '姓名',
  'student_id': '学号',
  'no_assignment_found': '目前无任何课程作业',
  'please_enter_course_name': '请输入课程名称...',
  'update': '更新课程',
  'add_course': '建立课程',
  'course_category': '课程类别',
  'daily_english': '生活类课程',
  'travel_shopping_english': '旅游类课程',
  'course_level': '课程级别',
  'show_selected': '已选择课程',
  'show_unselected': '未选择课程',
  'course_has_not_been_saved_notice': '您并未储存课程，关闭后资料将会遗失。 ',
  'please_name_this_course': '课程名称不得为空白',
  'please_choose_course': '需选择课程',
  'no_course_found': '目前无任何课程',
  'my_favorites': '我的最爱',
  'all_courses': '课程清单',
  'selected_courses': '已选清单',
  'new_course': '新增课程',
  'course_assignment_deleting_confirm': '课程指派中，若删除清单，学习纪录会一并删除。 ',
  'add_recourse': '新增资源',
  'keyword': '关键字',
  'search': '搜寻',
  'show_my_uploads_only': '只显示我的档案',
  'view': '查阅',
  'upload_files': '上传档案',
  'file_formats': '档案上传格式限制',
  'picture_format_required': '图片：jpg, png (最大2M)',
  'video_format_required': '影片：mp4 (最大25M)',
  'audio_format_required': '声音：mp3 (最大25M)',
  'online_resources_management': '资源管理',
  'please_choose_a_file': '请选择档案',
  'by_course': '课程纪录列表',
  'by_assignment': '课程作业纪录',
  'by_test': '考试成绩列表',
  'no_result_found': '目前无资料',
  'score': '班级成绩',
  'class_performance': '全班平均',
  'view_individual': '学生成绩',
  'individual_student': '学生成绩名单',
  'statistics': '个人成绩',
  'assignment': '课程作业',
  'test_history': '考试历程',
  'not_taken': '未考',
  'view_details': '查阅纪录',
  'test_assigned': '指派考试',
  'score_management': '成绩管理',
  'video': '影片',
  'transcript': '文字',
  'quiz': '测验',
  'follow': '跟读',
  'all': '全部',
  'single': '单句',
  'times': '次数',
  'cosplay': '角色扮演',
  'interactive': '互动',
  'type': '类型',
  'percentage': '比率',
  'category': '主题排行',
  'top_courses': '单元排行',
  'course_reports': '课程统计',
  'no_report_found': '目前无任何学习纪录',
  'learning_record': '学习纪录',
  'email': '电子信箱',
  'add_student': '新增学生',
  'import': '汇入名单',
  'export': '汇出名单',
  'no_student_found': '目前无任何学生',
  'student_management': '学生管理',
  'complete_list_of_students': '全部学生名单',
  'add_teacher': '新增老师',
  'no_teacher_found': '目前无任何老师',
  'teacher_management': '老师管理',
  'complete_list_of_teachers': '全部老师名单',
  'online_resources': '线上资源',
  'message': '讯息',
  'history': '历史纪录',
  'learning_record_mgr': '成绩管理',
  'customer_service': '客户服务',
  'lesson_language': '课程语言',
  'lesson_category': '课程类别',
  'lesson_level': '课程等级',
  'add_or_select_list': '新增或选择清单',
  'select_class': '选择班级',
  '_finish': '完成',
  'input_name': '输入名称',
  'select_course': '选择课程',
  'select_exam': '选择考试',
  'select_student': '选择学生',
  'input_data': '输入资料',
  'generated_time': '建立时间',
  'course': '共 {count} 课程',
  'upload': '上传附件',
  'click_coursework_list': '点击开始建立课程作业清单',
  'without_coursework_list': '没有课程作业清单',
  'without_class_list': '没有班级清单',
  'noData': '尚无资料',
  'without_list_of_assigned_coursework': '目前没有任何已建立的指派课程作业清单',
  'without_list_of_established_classes': '目前没有任何已建立的班级',
  'without_list_of_established information': '目前没有任何已建立的资讯',
  'coursework_list_name': '课程作业清单名称',
  'Please_enter_name': '请输入名称...(限制10个字)',
  '_language': '语言',
  '_category': '类别',
  '_level': '等级',
  'attachment_list': '附件列表',
  'upload_tips': '点击选择要上传的附件(请从您的电脑里选择要上传的档案)',
  'upload_rules': '档案大小格式不限，一次只能上传一个档案',
  'class_list': '班级清单',
  'selected_class': '已选班级',
  'student_list': '学生清单',
  'selected_student': '已选学生',
  'student': '共 {count} 位学生 ',
  'Please_enter_username': '请输入账号...(限制10个字)',
  'Please_enter_password': '请输入密码...(限制10个字)',
  'Please_enter_user_name': '请输入姓名...(限制10个字)',
  'Please_enter_student_id': '请输入学号...(限制10个字)',
  'create_class': '点击开始建立班级',
  'download_excel': '下载报表文件',
  'upload_excel': '上传报表文件',
  'download_demo': '下载模版',
  'assignment_score': '作业成绩',
  'assignment_list': '作业成绩列表清单',
  'frequency_of_study': '学习次数',
  'study_time': '学习总时间',
  'will_assign': '您将指派',
  'list_of_coursework_for': '的课程作业清单',
  'you_have_assigned': '您已指派',
  'add_single_student': '新增单笔学生',
  'import_students': '报表批次汇入学生',
  'note': '注意！此动作无法恢复。 ',
  'want_delete': '没错，我要删除',
  'successfully_deleted': '删除成功!',
  'coursework_deleted_successfully.': '课程作业已删除成功.',
  'Unassigned': '已取消指派',
  'class_deleted_successfully': '班级已删除成功',
  'next_step': '下一步',
  'upload_progress': '上传进度',
  'contains_course_attachments': '包含 {count} 个课程附件',
  'select_question': '选择题',
  'examination_content': '考试内容',
  'assign_class': '指派班级',
  'number_of_courses': '课程数量',
  'assigned_time': '指派时间',
  'course_content': '课程內容',
  'no_coursework_assigned': '没有分配任何课程作业',
  'no_assigned_courses': '目前没有老师分配任何课程给您',
  'course_list': '课程列表',
  'attachment_file': '附件档案',
  'start_the_course': '开始课程',
  'browsing_history': '浏览纪录',
  'watch_time': '观看时间',
  'after-class_test': '课后测验',
  'watch_date': '观看日期',
  'explain': '讲解',
  'explain_video': '讲解影片',
  'lesson': '课程',
  'graphical_words': '图解单字',
  'no_courses_found': '查无任何课程',
  'no_courses_in_category': ' 此类别没有任何课程',
  'add_students_in_batches': '批次新增学生',
  'results_of_after_school_test': '您的课后测验结果为',
  'correct': '答案正确',
  'wrong': '答案错误',
  'answer_rate': '答对率',
  'restart': '重新开始',
  'submit': '送出答案',
  'go_to_writing_course': '前往写作课程',
  'content': '內容',
  'play': '播放',
  'text': '课文',
  'fill_in_the_blank': '填空',
  'understanding': '理解',
  'sentence': '句子',
  'reorganization': '重组',
  'cumulative_number_of_views': '本课观看累积次数',
  'cumulative_times': '累积次数',
  'last_update': '最后更新时间',
  'cumulative_hours_of_views': '本课观看累积时数',
  'accumulated_hours': '累积时数',
  'select_sentence': '请选择句子',
  'recording_start': '录音开始',
  'recording_end': '录音结束',
  'voice_recognition': '语音辨识中...',
  'listen_sentence': '请聆听句子',
  'countdown': '倒数{count}秒后',
  'change_password': '修改密码',
  'confirm': '确定',
  'enter_old_password': '输入旧密码...',
  'enter_new_password': '输入新密码...',
  'enter_new_password_again': '再次输入新密码...'
}




// WEBPACK FOOTER //
// ./src/locales/zh_cn.js